import { micromark } from "micromark";
import { gfm, gfmHtml } from "micromark-extension-gfm";
import { HtmlExtension } from "micromark-util-types";
import { NodeHtmlMarkdown, TranslatorConfigObject } from "node-html-markdown";

import {
  emptyLinesHtmlExtension,
  emptyLinesSyntaxExtension,
} from "src/base-components/TextEditor/emptyLinesExtension";

const DEFAULT_TRANSLATORS: TranslatorConfigObject = {
  pre: {
    prefix: "\n```\n",
    postfix: "```",
    noEscape: true,
  },
};

const KEEP_EMPTY_LINES_TRANSLATORS: TranslatorConfigObject = {
  ...DEFAULT_TRANSLATORS,
  br: {
    content: "&nbsp;",
    recurse: false,
  },
};

const gfmHtmlExtensions: HtmlExtension = {
  ...gfmHtml(),
  enter: {
    ...gfmHtml().enter,
    strikethrough() {
      this.tag("<s>");
    },
  },
  exit: {
    ...gfmHtml().exit,
    strikethrough() {
      this.tag("</s>");
    },
  },
};

type ToMarkdownOptions = {
  keepEmptyLines?: boolean;
};

/**
 * @internal Internal to TextEditor — use MarkdownRenderer for rendering markdown elsewhere.
 */
export const mdService = {
  toMarkdown: (html: string, options: ToMarkdownOptions = {}) => {
    return NodeHtmlMarkdown.translate(
      html,
      {},
      options.keepEmptyLines
        ? KEEP_EMPTY_LINES_TRANSLATORS
        : DEFAULT_TRANSLATORS,
    ).trim();
  },
  toHtml: (markdown: string) =>
    micromark(markdown, {
      extensions: [gfm(), emptyLinesSyntaxExtension],
      htmlExtensions: [gfmHtmlExtensions, emptyLinesHtmlExtension],
    }).trim(),
};
